import { Text } from '#atoms';
import { Container, LabelButton } from './styles';

interface Props {
  label: string;
  active?: boolean;
  defaultButtonText: string;
  disabled?: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
}

export function LabelWithButton({
  label,
  active,
  defaultButtonText,
  disabled,
  onClick,
  style = {}
}: Props) {
  return (
    <Container>
      <Text>{label}</Text>
      <div>
        <LabelButton
          style={style}
          onClick={onClick}
          disabled={disabled}
          isActive={active}
        >
          {defaultButtonText}
        </LabelButton>
      </div>
    </Container>
  );
}
